import React, { createElement }  from 'react'
import { formatImage } from '@ifeng-fe/public_method'
import Observer from '@researchgate/react-intersection-observer'

interface FormatImageProps {
    src: string // 图片地址
    formatType: 0 | 1 | 2 | 3 // 0 不裁图，1 裁一倍图，2 裁2倍图, 3 自适应，普通屏1倍，高分屏2倍
    formatWidth?: number // 图片裁图的宽度，基于1倍图，可不填
    formatHeight?: number // 图片裁图的高度，基于1倍图，可不填

    alt?: string
    className?: string
    style?: object
}

export const FormatImage = (props: FormatImageProps) => {
    const { src, formatType, formatWidth, formatHeight, alt, className, style } = props

    const isLazyLoad = window.pageData
        ? JSON.parse(window.pageData.config).lazyLoad
        : (
            window.allData
                ? window.allData.lazyLoad
                : false
        )

    const GetFormatImageSrc = () => {
        switch (formatType) {
            case 0: return src;
            case 1: return formatImage(src, formatWidth, formatHeight);
            case 2: return formatImage(src, formatWidth * 2, formatHeight * 2);
            case 3: return formatImage(src, formatWidth, formatHeight);
        }
    }

    const handleObserverChange = (entry, unobserve) => {
        const { isIntersecting, target } = entry;

        if (isIntersecting) {
            const { src } = target.dataset
            target.setAttribute('src', src)
            unobserve();
        }
    }

    if (isLazyLoad) {
        return (
            <Observer
                rootMargin="0px 0px 400px 0px"
                onChange={(entry, unobserve) => handleObserverChange(entry, unobserve)}>
                <img
                    data-src={GetFormatImageSrc()}
                    alt={alt}
                    className={className}
                    style={{ ...style }}
                    {...(formatType === 3 ? { srcSet: `${formatImage(src, formatWidth, formatHeight)} 1x, ${formatImage(src, formatWidth * 2, formatHeight * 2)} 2x` } : {})}
                />
            </Observer>
        )
    } else {
        return (
            <img
                src={GetFormatImageSrc()}
                alt={alt}
                className={className}
                style={{ ...style }}
                {...(formatType === 3 ? { srcSet: `${formatImage(src, formatWidth, formatHeight)} 1x, ${formatImage(src, formatWidth * 2, formatHeight * 2)} 2x` } : {})}
            />
        )
    }
}
